import { getArticleGroupContent } from './getArticleGroupContent';

/**
 * Extracts content for the ArticleGroup component.
 * @param {Array} related Array of objects that have a type and content key.
 * @param {String} key    What key to look for. Defaults to similar products.
 * @param {object} extraClassNames    Extra class names in key-value object.
 */
export function getSimilarProductContent({
  related,
  key = 'similarProducts',
  extraClassNames = { '-default': true },
}) {
  return getArticleGroupContent({ related, key }).map(item => ({
    ...item,
    // without extra class names ArticleGroup wont render data
    extraClassNames,
  }));
}
